import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'partnershipDeals/deal';
const model = 'partnershipDeals/deal';
const modelExposedName = 'Partnership Deal';
const wizardAction = 'create';

const Create = (params) => {

    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const [drawable, setDrawable] = useState(false);
    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.stack);

    const { createConfig: detailConfig } = existingModules[dataProviderName];

    useEffect(() => {
        loadOne(null).then(e => setDrawable(true));
    }, []);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    const inheritedData = Object.fromEntries(
        Object.entries({
            parentDeal: discover('parentDeal'),
            partner: discover('parentDeal.partner'),
            start_at: discover('parentDeal.start_at'),
            end_at: discover('parentDeal.end_at'),

            threshold_1: discover('parentDeal.threshold_1'),
            bonus_type_1: discover('parentDeal.bonus_type_1'),
            bonus_value_1: discover('parentDeal.bonus_value_1'),
            bonus_stack_1: discover('parentDeal.bonus_stack_1'),

            threshold_2: discover('parentDeal.threshold_2'),
            bonus_type_2: discover('parentDeal.bonus_type_2'),
            bonus_value_2: discover('parentDeal.bonus_value_2'),
            bonus_stack_2: discover('parentDeal.bonus_stack_2'),

            threshold_3: discover('parentDeal.threshold_3'),
            bonus_type_3: discover('parentDeal.bonus_type_3'),
            bonus_value_3: discover('parentDeal.bonus_value_3'),
            bonus_stack_3: discover('parentDeal.bonus_stack_3'),

            threshold_4: discover('parentDeal.threshold_4'),
            bonus_type_4: discover('parentDeal.bonus_type_4'),
            bonus_value_4: discover('parentDeal.bonus_value_4'),
            bonus_stack_4: discover('parentDeal.bonus_stack_4')
        }).filter(([_, value]) => value != null && value !== '')
    );

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
                <DetailComponent
                    values={{
                        ...item?.data,
                        ...inheritedData
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t('New {{itemname}}', { itemname: t(modelExposedName) })}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t('Create new {{itemname}}', { itemname: t(modelExposedName) })}
                            subtitle={t('Fill the basic information to create a new {{itemname}} that you will be able to edit via the standard interface', { itemname: t(modelExposedName) })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default Create;